<template>
  <div class="ActivityReportItem">
    <div class="name">
      {{ label }}
    </div>
    <IncrementInput
      @change="update"
      :disabled="readOnly"
      v-model.number="quantity" />
    <div
      v-if="error"
      class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
const labels = {
  pt_hours: "PT Hours",
  pt_start: "PT Start",
  pt_50_min: "PT time 50 min",
  pt_25_min: "PT time 25 min",
  service_intro: "Servicetimer - introtime",
  service_campaign: "Servicetimer - kampanje",
  service_outside: "Servicetimer - utenfor senter",
  service_inside: "Servicetimer - på senter",
};

import debounce from "lodash/debounce";
import gql from "graphql-tag";
import IncrementInput from "@/components/IncrementInput";
export default {
  components: { IncrementInput },
  data: function () {
    return { error: null };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {},

  methods: {
    update: debounce(
      function () {
        if (this.item.quantity < 0) {
          this.error = "Must be 0 or more";
          return;
        }
        this.error = null;
        console.log("updating item");
        return this.$apollo
          .mutate({
            mutation: gql`
              mutation UpdateActivityReportItemMutation(
                $id: Int!
                $quantity: BigFloat!
              ) {
                __typename
                updateActivityReportItem(
                  input: { patch: { quantity: $quantity }, id: $id }
                ) {
                  clientMutationId
                }
              }
            `,
            variables: {
              id: this.item.id,
              quantity: this.item.quantity,
            },
          })
          .then((response) =>
            this.$emit("activity-report-item-updated", response)
          )
          .catch((err) => console.error("failed to save report item", err));
      },
      500,
      { leading: true }
    ),
  },

  computed: {
    label() {
      return labels[this.item.category];
    },
    quantity: {
      get: function () {
        return parseInt(this.item.quantity);
      },
      set: function (val) {
        this.item.quantity = val;
      },
    },
  },

  filters: {},
};
</script>

<style lang="scss" scoped>
.ActivityReportItem {
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--pale-grey);
  name {
    flex: 1;
  }
  input {
    width: 5em;
  }
  .error {
    color: var(--red-pink);
    font-size: 0.8em;
    padding-left: 0.5em;
  }
}
</style>
